module.exports = __webpack_public_path__ + "img/cover.d0f4aa0c.webp";